<!-- eslint-disable vue/no-mutating-props -->
<template>
  <v-container fluid>
    <!-- LEAD DETAILS -->
    <v-card
      outlined
      flat
    >
      <v-card-title class="pb-2">
        Lead Details
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-select
              id="api_key"
              v-model="formData.api_key"
              :items="leadProviders"
              label="Lead Provider"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-select
              id="campaign"
              v-model="formData.campaign"
              :items="filteredCampaigns"
              label="Campaign"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
            lg="4"
          >
            <v-text-field
              id="ip_address"
              v-model="formData.ipaddress"
              label="IP Address"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
            lg="4"
          >
            <v-text-field
              id="affiliate_id"
              v-model="formData.affid"
              label="Affiliate ID"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
            lg="4"
          >
            <v-text-field
              id="test"
              v-model="formData.test"
              label="Test"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
            lg="4"
          >
            <v-text-field
              id="test_type"
              v-model="formData.testtype"
              label="Test Type"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
            lg="4"
          >
            <v-text-field
              id="request_amount"
              v-model="formData.requestamount"
              label="Request Amount"
              type="number"
              outlined
              dense
              prefix="$"
            />
          </v-col>

          <v-col
            v-if="isPrescreenCustomer"
            cols="12"
            md="6"
            lg="4"
          >
            <v-text-field
              id="prescreen_campaign_id"
              v-model="formData.prescreen_campaign_id"
              label="Prescreen Campaign ID"
              type="number"
              outlined
              dense
            />
          </v-col>
        </v-row>

        <!-- Return Customer Section -->
        <template v-if="isReturnCustomer">
          <v-divider class="my-4" />
          <h4 class="mb-3 text--secondary">
            Return Customer
          </h4>

          <v-row>
            <v-col cols="12">
              <v-alert
                v-if="customers.length > 0"
                text
                type="info"
                border="left"
                class="mb-3"
              >
                Please choose the customer you want to return as.
              </v-alert>
              <v-alert
                v-else
                text
                type="error"
                border="left"
                class="mb-3"
              >
                There are no customers to return as. Create a "Purchased" or "Walkup" lead first.
              </v-alert>
            </v-col>

            <v-col
              cols="12"
              md="6"
              lg="4"
            >
              <v-select
                id="customer"
                v-model="formData.customer_guid"
                :items="customers"
                label="Customer"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </template>
      </v-card-text>
    </v-card>

    <!-- CUSTOMER INFO -->
    <v-card
      class="my-3 "
      outlined
    >
      <v-card-title class="pb-2">
        Customer Information
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-row>
          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <v-text-field
              id="first_name"
              v-model="formData.firstname"
              label="First Name"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <v-text-field
              id="last_name"
              v-model="formData.lastname"
              label="Last Name"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <v-text-field
              id="ssn_number"
              v-model="formData.ssn"
              label="SSN"
              type="number"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <v-text-field
              id="date_of_birth"
              v-model="formData.dob"
              label="Date of Birth"
              type="date"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              id="home_phone"
              v-model="formData.homephone"
              label="Home Phone"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              id="email"
              v-model="formData.email"
              label="Email"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="8"
          >
            <v-text-field
              id="address_line_1"
              v-model="formData.address"
              label="Address Line 1"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              id="address_line_2"
              v-model="formData.address2"
              label="Address Line 2"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              id="city"
              v-model="formData.city"
              label="City"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-select
              id="us_states"
              v-model="formData.state"
              label="State"
              :items="usStates"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              id="zip"
              v-model="formData.zip"
              label="Zip"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-select
              id="rent_or_own"
              v-model="formData.rentorown"
              label="Rent or Own?"
              :items="rentOwnItems"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              id="address_months"
              v-model="formData.addressmonths"
              label="Address Months"
              type="number"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              id="address_years"
              v-model="formData.addressyears"
              label="Address Years"
              type="number"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-select
              id="drivers_license_state"
              v-model="formData.dlstate"
              label="Driver's License State"
              :items="usStates"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              id="drivers_license_number"
              v-model="formData.dlnumber"
              label="Driver's License Number"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-select
              id="military"
              v-model="formData.ismilitary"
              label="Military?"
              :items="booleanItems"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-select
              id="citizen"
              v-model="formData.iscitizen"
              label="Citizen?"
              :items="booleanItems"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-select
              id="other_offers"
              v-model="formData.otheroffers"
              label="Other Offers?"
              :items="booleanItems"
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- EMPLOYMENT INFO -->
    <v-card
      class="my-3 "
      outlined
    >
      <v-card-title class="pb-2">
        Employment Information
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-alert
          v-if="formData.payfrequency === 'S'"
          text
          color="info"
          class="mb-4"
        >
          You have selected the payment frequency <strong>semi-monthly</strong>,
          for which payments must be the first or the fifteenth!
        </v-alert>

        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              id="employer_name"
              v-model="formData.empname"
              label="Employer Name"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              id="employer_phone"
              v-model="formData.empphone"
              label="Employer Phone"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              id="phone_ext"
              v-model="formData.empphoneext"
              label="Ext."
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              id="hire_date"
              v-model="formData.hiredate"
              label="Hire Date"
              type="date"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              id="emp_months"
              v-model="formData.empmonths"
              label="Employed Months"
              type="number"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              id="emp_years"
              v-model="formData.empyears"
              label="Employed Years"
              type="number"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              id="net_monthly"
              v-model="formData.netmonthly"
              label="Net Monthly"
              type="number"
              outlined
              dense
              prefix="$"
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              id="gross_monthly"
              v-model="formData.grossmonthly"
              label="Gross Monthly"
              type="number"
              outlined
              dense
              prefix="$"
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-select
              id="income_type"
              v-model="formData.incometype"
              label="Income Type"
              :items="incomeTypeItems"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-select
              id="pay_type"
              v-model="formData.paytype"
              label="Pay Type"
              :items="payTypeItems"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-select
              id="pay_frequency"
              v-model="formData.payfrequency"
              label="Pay Frequency"
              :items="payFrequencyItems"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              id="last_pay_date"
              v-model="formData.lastpaydate"
              label="Last Pay Date"
              type="date"
              outlined
              dense
              disabled
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              id="next_pay_date"
              v-model="formData.nextpaydate"
              label="Next Pay Date"
              type="date"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              id="second_pay_date"
              v-model="formData.secondpaydate"
              label="Second Pay Date"
              type="date"
              outlined
              dense
              disabled
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- BANK INFO -->
    <v-card
      class="my-3 "
      outlined
    >
      <v-card-title class="pb-2">
        Bank Information
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              id="bank_name"
              v-model="formData.bankname"
              label="Bank Name"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-select
              id="account_type"
              v-model="formData.accounttype"
              label="Account Type"
              :items="accountTypeItems"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              id="routing_number"
              v-model="formData.routingnumber"
              label="Routing Number"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              id="account_number"
              v-model="formData.accountnumber"
              label="Account Number"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              id="bank_months"
              v-model="formData.bankmonths"
              label="Bank Months"
              type="number"
              outlined
              dense
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              id="bank_years"
              v-model="formData.bankyears"
              label="Bank Years"
              type="number"
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: {
    leadData: {
      type: Object,
      default() {
        return {};
      },
    },
    leadProviders: {
      type: Array,
      default() {
        return [];
      },
    },
    campaigns: {
      type: Array,
      default() {
        return [];
      },
    },
    usStates: {
      type: Array,
      default() {
        return [];
      },
    },
    customers: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      incomeTypeItems: [
        { text: 'Employment', value: 'E' },
        { text: 'Disability', value: 'D' },
        { text: 'Social Security', value: 'S' },
        { text: 'Unemployment', value: 'U' },
        { text: 'Pension', value: 'P' },
        { text: 'Other', value: 'O' },
      ],
      payTypeItems: [
        { text: 'Direct Deposit', value: 'D' },
        { text: 'Paper Check', value: 'P' },
        { text: 'Cash', value: 'C' },
      ],
      payFrequencyItems: [
        { text: 'Weekly', value: 'W' },
        { text: 'Bi-weekly', value: 'B' },
        { text: 'Semi-monthly', value: 'S' },
        { text: 'Monthly', value: 'M' },
      ],
      accountTypeItems: [
        { text: 'Checking', value: 'C' },
        { text: 'Savings', value: 'S' },
      ],
      booleanItems: [
        { text: 'Yes', value: 'true' },
        { text: 'No', value: 'false' },
      ],
      rentOwnItems: [
        { text: 'Own', value: 'O' },
        { text: 'Rent', value: 'R' },
      ],

      formData: this.leadData,
    };
  },

  computed: {
    filteredCampaigns() {
      return this.campaigns.filter((campaign) => campaign.apiKey === this.formData.api_key);
    },

    isReturnCustomer() {
      return this.campaigns
        .find((c) => c.value === this.formData.campaign)
        ?.leadCategory === 'Return';
    },

    isPrescreenCustomer() {
      return this.campaigns
        .find((c) => c.value === this.formData.campaign)
        ?.leadCategory === 'Prescreen';
    },
  },

  watch: {
    formData: {
      deep: true,
      handler(newVal) {
        this.$emit('update:leadData', { ...newVal });
      },
    },
    'formData.payfrequency': {
      deep: true,
      handler() {
        this.$emit('changedFrequency', this.formData.payfrequency);
      },
    },
    'formData.nextpaydate': {
      deep: true,
      handler() {
        this.$emit('changedNextPayDate', {
          payFrequency: this.formData.payfrequency,
          nextPayDate: this.formData.nextpaydate,
        });
      },
    },
    'formData.api_key': {
      handler() {
        this.formData = {
          ...this.formData,
          campaign: null,
        };
      },
    },
    isReturnCustomer() {
      if (this.isReturnCustomer) {
        this.formData = {
          ...this.formData,
          return_customer: 1,
          customer_guid: this.customers[0]?.value || null,
        };
        return;
      }

      this.formData = {
        ...this.formData,
        return_customer: 0,
        customer_guid: null,
      };
    },
    'formData.customer_guid': {
      handler() {
        const activeCustomer = this.customers.find(
          (customer) => customer.value === this.formData.customer_guid,
        );

        if (activeCustomer) {
          this.formData = {
            ...this.formData,
            email: activeCustomer.email,
          };
        }
      },
    },
  },

  methods: {},
};
</script>
